import type { MouseEvent } from 'react';
import { forwardRef, useCallback } from 'react';
import Checkbox from '@wix/da-ds/pkg/Checkbox';
import BaseListItem from '../BaseListItem';
import BaseListCell from '../BaseListItem/BaseListCell';

interface Props {
  className?: string;
  selectCellClassName?: string;
  offset: number;
  selected: number[];
  onSelect: (index: number, isSelected: boolean, isShiftKey?: boolean) => void;
  isDragging?: boolean;
}

const SelectableListItem = forwardRef<HTMLLIElement, React.PropsWithChildren<Props>>(
  ({ offset, selected, onSelect, isDragging, children, className, selectCellClassName }, ref) => {
    const isSelected = selected.includes(offset);
    const onRowCheckboxClick = useCallback(
      (ev: MouseEvent) => {
        ev.preventDefault();
        onSelect(offset, !isSelected, ev.shiftKey);
      },
      [onSelect, isSelected, offset]
    );

    return (
      <BaseListItem className={className} isSelected={isSelected} isDragging={isDragging} ref={ref}>
        <BaseListCell className={selectCellClassName}>
          <Checkbox isChecked={isSelected} onClick={onRowCheckboxClick} />
        </BaseListCell>
        {children}
      </BaseListItem>
    );
  }
);
SelectableListItem.displayName = 'SelectableListItem';

export default SelectableListItem;
